WiseMetering.Views.ShowSpheraIntegration = WiseMetering.Views.Content.extend({
    icon: 'wiseStore',

    initialize({ model, view }) {
        const partner = model.partner();
        this.name = `${partner?.get('name')} > ${this.model.get('name')}`;
        this.tabs = [
            {
                active: view === 'details',
                href: `/integrations/${model.id}/details`,
                id: 'details',
                name: i18next.t('common.details'),
                view: WiseMetering.Views.SpheraIntegrationDetails
            }
        ];

        if (WiseMetering.currentUser.get('superuser')) {
            this.tabs.push({
                active: view === 'logs',
                href: `/integrations/${model.id}/logs`,
                id: 'logs',
                name: i18next.t('glossary.logs'),
                view: WiseMetering.Views.IntegrationLogs
            });
        }
    }

    // serializeData: function() {
    //     return {
    //         ...this.model.toJSON(),
    //         site: this.model.site(),
    //         // configurationName: this.model.configuration().get('name'),
    //         indicator: this.model.indicator()
    //     };
    // }
});
